import customizable from './icons/customizable.svg';
import FitnessPlan from './icons/fitnessPlan.svg';
import Library from './icons/library.svg';
import WorkoutHistory from './icons/workoutHistory.svg';

export const features = [
    {
        feature: 'subscription.confirmationModal.feature1',
        icon: Library,
    },
    {
        feature: 'subscription.confirmationModal.feature2',
        icon: FitnessPlan,
    },
    {
        feature: 'subscription.confirmationModal.feature3',
        icon: WorkoutHistory,
    },
    {
        feature: 'subscription.confirmationModal.feature4',
        icon: customizable,
    },
];
